/**
 * Shared pagination constants for the admin dashboard tables.
 *
 * The dashboard "Recent Runs" table and the org-detail "Runs" table page at the
 * same size; keep the value in one place so the two can't drift.
 */

/** Rows per page for the admin Runs tables (dashboard + org-detail). */
export const ADMIN_RUNS_PER_PAGE = 10;
